import React from "react"

export default function Footer()
{
    return (
        <footer className="footer">
            <div className="footer-bar bg-overlay bg-img"></div>
            <div className="container">
                <span className="text-muted">
                    &copy; Copyright {new Date().getFullYear()}&nbsp;&nbsp;
                    <a href="/">wiltOS Technologies</a>&nbsp;All Rights Reserved |&nbsp;
                    <a href="/terms-of-service">Terms of Service</a> |&nbsp;
                    <a href="/privacy-policy">Privacy Policy</a>
                </span>

                <span className="fl-right">
                    <a
                    href="https://www.facebook.com/wiltOSTech/"
                    target="_blank"
                    title="facebook"
                    className="ml-1"
                    rel="noopener noreferrer"
                    >
                    <i className="fab fa-facebook-f" />
                    </a>
                    <a
                    href="https://twitter.com/wiltOSTech"
                    target="_blank"
                    title="twitter"
                    className="ml-1"
                    rel="noopener noreferrer"
                    >
                    <i className="fab fa-twitter" />
                    </a>
                    <a
                    href="https://www.linkedin.com/company/11260344/"
                    target="_blank"
                    title="linkedin"
                    className="ml-1"
                    rel="noopener noreferrer"
                    >
                    <i className="fab fa-linkedin-in" />
                    </a>
                    <a
                    href="https://www.youtube.com/channel/UCSiK-3Sug7wN6-KeJ1WKUgg"
                    target="_blank"
                    title="youtube"
                    className="ml-1"
                    rel="noopener noreferrer"
                    >
                    <i className="fab fa-youtube" />
                    </a>
                    <a
                    href="https://discord.gg/VVDzG2mrb6"
                    target="_blank"
                    title="discord"
                    className="ml-1"
                    rel="noopener noreferrer"
                    >
                    <i className="fab fa-discord" />
                    </a>
                </span>
            </div>
        </footer>
    )
}